var map = {
	"./03_feldman_WIR SIND HIER_video installation Kopie.webp": 5339,
	"./04_feldman_Grief is Data Cut from Blue Sky_installation.webp": 6933,
	"./08_feldman_The Violence We Have Witnessed Carries a Weight on Our Hearts_installation.webp": 4958,
	"./09_feldman_Elegy_film still.webp": 2113,
	"./11_feldman_After One Year_film still.webp": 9134,
	"./12_feldman_White Supremacist Terror Halle_film stills.webp": 1805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2635;